module.exports = __webpack_public_path__ + "static/media/Dap-Tour.4ca0fcbd.mp4";